import { useMemo } from 'react'

import { T, VStack } from 'govwell-ui'

import { AcceptedAllFileTypes } from 'src/constants'
import { ListEnding, formatListSentence } from 'src/utils'

import { BreakpointComponents } from '../../../constants/breakpoints'
import { useCurrentBreakpoint } from '../../../hooks/use-current-breakpoint'

type Props = {
  accept?: string
}
export const Default = ({ accept }: Props) => {
  const supportedFileTypes = useMemo(() => {
    if (!accept || accept === AcceptedAllFileTypes) {
      return 'All file types accepted'
    }
    return formatListSentence({
      words: accept?.replaceAll('.', '')?.toUpperCase()?.split(',') || [],
      hideFinalPeriod: true,
      finalItemDelimiter: ListEnding.OR,
    })
  }, [accept])

  const { isSmall } = useCurrentBreakpoint()
  const small = isSmall(BreakpointComponents.FileUpload)

  return (
    <VStack gap={1} align="center" justify="center" className="relative">
      {/* Default content - hidden when dragging over */}
      <T.Body className="text-link hover:underline [.ant-upload-drag-hover_&]:invisible">
        Drag and drop files here or click to upload
      </T.Body>
      {!small && (
        <T.BodySmall className="text-neutral-600 [.ant-upload-drag-hover_&]:invisible">
          {supportedFileTypes}
        </T.BodySmall>
      )}
      {/* Drag-over content - only visible when dragging */}
      {/* pointer-events-none prevents this overlay from capturing drag events which would cause flickering */}
      <div className="pointer-events-none absolute inset-0 hidden items-center justify-center [.ant-upload-drag-hover_&]:flex">
        <T.Body className="text-orange-500">Add file</T.Body>
      </div>
    </VStack>
  )
}
